/**
 * Textarea Component — Yoluno design system
 *
 * Matches Input: var(--radius-md), border-default, brand border + focus-ring on focus.
 */

import * as React from 'react';
import { cn } from '@/lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          [
            'flex min-h-[80px] w-full',
            'rounded-[var(--radius-md)]',
            'border border-[var(--border-default)]',
            'bg-[var(--surface-card)]',
            'px-4 py-3',
            'font-body text-body-sm text-[var(--text-body)]',
            'shadow-[var(--shadow-xs)]',
            'transition-[border-color,box-shadow] duration-[var(--dur-base)] [transition-timing-function:var(--ease-out)]',
            'placeholder:text-[var(--text-soft)]',
            'focus-visible:outline-none focus-visible:border-[var(--border-brand)] focus-visible:shadow-[var(--focus-ring)]',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'resize-y',
          ].join(' '),
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
